import React, {useEffect} from "react";
import "./App.css";
import "./responsive.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {useAuth} from "./context/authcontext";
import { FlashProvider } from "./context/flashcontext";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import NavigationContainer from "./components/Navigation/NavigationContainer";
import Login from "./components/Login/LoginContainer";
import Register from "./components/Register/RegisterContainer";
import ProfileContainer from "./components/Profile/ProfileContainer";
import ProjectsContainer from "./components/Projects/ProjectsContainer";
import RequireAuth from "./components/Middleware/requireauth.component";
import ProjectDetailContainer from "./components/Projects/ProjectDetailContainer";
import TimesheetListContainer from "./components/Timesheets/TimesheetListContainer";
import TimesheetFormContainer from "./components/Timesheets/TimesheetFormContainer";
import TimesheetDetailContainer from "./components/Timesheets/TimesheetDetailContainer";
import PendingTimesheetsContainer from "./components/Timesheets/PendingTimesheetsContainer";
import ActivateAccountContainer from "./components/ActivateAccount/ActivateAccountContainer";
import ProjectTimeSheetListContainer from "./components/Projects/ProjectTimeSheetListContainer";
import ResetPasswordContainer from "./components/Login/ResetPasswordContainer";
import ForgotPasswordContainer from "./components/Login/ForgotPasswordContainer";
import Dashboard from "./components/Dashboard/DashboardContainer";
import Requireguest from "./components/Middleware/requireguest.component";
import UserListContainer from "./components/Users/UserListContainer";
import UserDetailContainer from "./components/Users/UserDetailContainer";
import CustomerListContainer from "./components/Customers/CustomerListContainer";
import CustomerDetailContainer from "./components/Customers/CustomerDetailContainer";
import AgendaContainer from "./components/Agenda/AgendaContainer";

function App() {
    const { checkAuth, loading } = useAuth();

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    if (loading) return <div className="app-loading">Laden...</div>;

  if (typeof window.localStorage === "undefined" || !window.localStorage) {
    console.error('localStorage is niet beschikbaar. Zorg dat opslag is ingeschakeld.');
  }

  return (
      <ErrorBoundary>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <FlashProvider>
                  <NavigationContainer />
                      <Routes>
                      <Route path="/" element={
                          <RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker"]}>
                            <Dashboard />
                          </RequireAuth>
                      } />

                      <Route path="/login" element={
                          <Requireguest>
                              <Login />
                          </Requireguest>
                      } />
                      <Route path="/register" element={
                          <Requireguest>
                            <Register />
                          </Requireguest>
                      } />
                      <Route path="/register/:code" element={
                          <Requireguest>
                              <Register />
                          </Requireguest>
                      } />
                      <Route path="/activate/:code" element={
                          <Requireguest>
                              <ActivateAccountContainer />
                          </Requireguest>
                        } />
                      <Route path="/profile" element={
                          <RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker", "klant"]}>
                            <ProfileContainer />
                          </RequireAuth>
                      } />
                        <Route path="/dashboard" element={
                            <RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker", "klant"]}>
                                <Dashboard />
                            </RequireAuth>
                        } />
                        <Route
                            path="/projects"
                            element={
                                <RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker", "klant"]}>
                                    <ProjectsContainer />
                                </RequireAuth>
                            }
                        />
                        <Route path="/projects/:id"
                           element={
                               <RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker", "klant"]}>
                                   <ProjectDetailContainer />
                               </RequireAuth>
                            }
                        />
                        <Route path="/projects/timesheets/:id"
                               element={
                                   <RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker", "klant"]}>
                                       <ProjectTimeSheetListContainer />
                                   </RequireAuth>
                               }
                        />
                        <Route path="/agenda"
                               element={
                                   <RequireAuth allowedRoles={["eigenaar", "financieel medewerker"]}>
                                       <AgendaContainer />
                                   </RequireAuth>
                               }
                        />
                        <Route path="/forgot-password" element={<ForgotPasswordContainer />} />
                        <Route path="/reset-password" element={<ResetPasswordContainer />} />
                        <Route path="/reset-password/:token" element={<ResetPasswordContainer />} />
                        <Route path="/timesheets" element={<RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker"]}><TimesheetListContainer /></RequireAuth>} />
                        <Route path="/timesheets/new" element={<RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker"]}><TimesheetFormContainer /></RequireAuth>} />
                        <Route path="/timesheets/:id/edit" element={<RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker"]}><TimesheetFormContainer /></RequireAuth>} />
                        <Route path="/timesheets/:id" element={<RequireAuth allowedRoles={["zzper", "eigenaar", "financieel medewerker", "klant"]}><TimesheetDetailContainer /></RequireAuth>} />
                        <Route path="/timesheets/pending" element={<RequireAuth allowedRoles={["eigenaar", "financieel medewerker"]}><PendingTimesheetsContainer /></RequireAuth>} />
                        <Route path="/users" element={<RequireAuth allowedRoles={["financieel medewerker", "eigenaar"]} allowVoorman={true}><UserListContainer /></RequireAuth>} />
                        <Route path="/users/:id" element={<RequireAuth allowedRoles={["financieel medewerker", "eigenaar"]} allowVoorman={true}><UserDetailContainer /></RequireAuth>} />
                        <Route path="/customers" element={<RequireAuth allowedRoles={["financieel medewerker", "eigenaar"]}><CustomerListContainer /></RequireAuth>} />
                        <Route path="/customers/:id" element={<RequireAuth allowedRoles={["financieel medewerker", "eigenaar"]}><CustomerDetailContainer /></RequireAuth>} />
                    </Routes>
          </FlashProvider>
        </Router>
      </ErrorBoundary>
  );
}

export default App;
